import type { ReactNode } from 'react';
import { ArrowLeft, Download } from 'lucide-react';
import { useScanDownload } from './scan-download';
import { StationArt } from './scan-art/StationArt';

export interface ScanStationProps {
  onBack: () => void;
}

/**
 * A scanning station without a browser: Paige Scan's own scan window, signed in once with the
 * person's Paige sign-in (the browser asks them to allow the computer; it keeps a device credential an
 * admin can revoke under Company, Scanners and devices). Not the folder monitor, which watches a folder
 * as a Windows service and is an admin's (Watch a folder).
 */
export function ScanStation({ onBack }: ScanStationProps): ReactNode {
  const { url } = useScanDownload();
  return (
    <div className="paige-scan-sheet paige-scan-station">
      <button type="button" className="paige-scan-back" onClick={onBack}>
        <ArrowLeft size={14} aria-hidden="true" />
        Back
      </button>
      <div className="paige-scan-setup">
        <header className="paige-scan-intro">
          <StationArt width={260} />
          <h2 id="paige-intake-title">Install Paige Scan and sign in</h2>
          <p>Its own scan window picks a job and scans, no browser needed.</p>
        </header>
        <a className="paige-scan-cta" href={url}>
          <Download size={16} aria-hidden="true" />
          Download Paige Scan
        </a>
      </div>
    </div>
  );
}
